<mat-form-field class="d-block f-right" appearance="outline">
  <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
  <mat-chip-grid #chipList aria-label="Chips selection">
    @for (item of formGroup.controls[field.name].value; track item) {
      <mat-chip (removed)="remove(item)" class="category-chip">
        <div class="category-chip__text">
          {{
            field.translate ? (displayFn(item) | i18nextCap) : displayFn(item)
          }}
        </div>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    }
    <input
      #chipsInput
      [placeholder]="
        field.placeholder
          ? ('translation:' + field.placeholder | i18nextCap)
          : ''
      "
      [formControl]="chipsAutocompleteCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (item of filteredOptions | async; track item) {
      @if (!isNewValueAlreadyAdded(item.id)) {
        <mat-option [value]="item">
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          @if (field.translate) {
            {{ 'forms:' + item.name | i18nextCap }}
          }
          @if (!field.translate) {
            {{ item.name | titlecase }}
          }
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
